<template>
  <div class="select-wrapper">
    <select
      @change="$emit('input', $event.target.value)"
      :class="{ 'dark': dark, 'disabled': disabled }"
    >
      <option
        v-for="(option, index) in options"
        :value="option.value"
        :key="index"
        :selected="option.selected"
        :disabled="option.disabled"
      >
        {{ option.label ? option.label : option.value }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'ProaSelect',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: [String, Number],
    options: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    const selectedOption = this.options.filter((option) => {
      return option.selected
    })
    if (!selectedOption.length) {
      const defaultOption = this.options.filter(option => {
        return !option.disabled
      })[0]
      if (defaultOption) {
        this.$emit('input', defaultOption.value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.select-wrapper {
  width: 100%;
  position: relative;
  display: inline-block;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 10px;
    margin-top: -4px;
    width: 6px;
    height: 6px;
    border: 0px;
    border-bottom: solid 1px #666666;
    border-right: solid 1px #666666;
    transform: rotate(45deg);
    pointer-events: none;
  }
}

select {
  width: 100%;
  appearance: none;
  padding: 6px 20px 6px 10px;
  background-color: white;
  border: 1px solid $dark-border-color;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  pointer-events: all;

  &.dark {
    background-color: $light-gray-color;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  &:focus {
    outline: none;
  }
}
</style>
